import { render, staticRenderFns } from "./ProjectsProfitAndLossReadOnlyPanel.vue?vue&type=template&id=77db80aa"
import script from "./ProjectsProfitAndLossReadOnlyPanel.vue?vue&type=script&lang=js"
export * from "./ProjectsProfitAndLossReadOnlyPanel.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports